import { Entity, Field } from "typegraph";

class Property {

	@Field()
	public id: any;

	@Field()
	public displayName: string;

	@Field() 
	public sortIndex: any;
}

class PropertyValue {
	@Field()
	public id: any;

	@Field()
	public value: string;

	@Field({entity: Property})
	public property: Property;
}

class UserPropertyValue {

	@Field()
	public id: any;

	@Field({entity: PropertyValue})
	public propertyValue: PropertyValue;

}

@Entity({ one: "userCurrent"})
export default class User {

	@Field()
	public id: any;

	@Field()
	public firstName: string;

	@Field()
	public lastName: string;

	@Field()
	public createDate: string;

	@Field()
	public avatarUrl: string | null;

	@Field({entity: UserPropertyValue})
	public properties: UserPropertyValue[] | null;

}



// WEBPACK FOOTER //
// ./src/panels/userDetails/entities/User.ts